import { createPinia } from 'pinia'
const pinia = createPinia()
export default pinia

import app from './modules/app'
import indexDB from './modules/indexDB'
import qiankun from './modules/qiankun'
const appStore = app()
const indexDBStore = indexDB()
const qiankunStore = qiankun()

export {
  appStore,
  indexDBStore,
  qiankunStore
}
